<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <p class="d-inline font-weight-bold d-block mb-0">{{ $t('editor.templates') }}</p>
      <!-- modal trigger -->
      <d-btn
        class="float-right mt-3 select-template"
        @click.native="handleClick"
      >{{ $t('editor.templatebutton') }}</d-btn>
      <!-- / modal trigger -->
    </d-card-header>
    <!-- Recently used templates -->
    <d-card-body class="p-3">
      <p
        v-if="recentTemplates.length"
        class="d-inline mb-1 font-weight-bold d-block mb-2"
      >{{ $t('editor.recenttemplates') }}</p>
      <div
        v-for="recentTemplate in recentTemplates"
        :key="recentTemplate.recentTemplate"
        class="last-used"
      >{{ recentTemplate }}</div>
    </d-card-body>

    <!-- Modal (Template Library) -->
    <d-modal size="lg" v-if="showModal" @close="handleClose">
      <d-modal-header>
        <d-modal-title>{{ $t('editor.selecttemplate') }}</d-modal-title>
      </d-modal-header>
      <d-modal-body class="pt-2 style-modal vh-80">
        <!-- Modal Navbar -->
        <d-nav pills class="mb-2 border-box nav-box">
          <d-nav-item v-for="tab in tableTabs" :key="tab.tabName" class="tab-nav" active>
            <div @click="selectTab(tab)">
              {{ tab.tabName }}
              <span>({{ getTemplates.filter(template => template.tags.includes(tab.tabTag)).length }})</span>
            </div>
          </d-nav-item>
        </d-nav>
        <hr class="m-0" />
        <message-templates :tab="tabSelected" />
      </d-modal-body>
    </d-modal>
    <!-- / Modal Template Library -->
  </d-card>
</template>

<script>
import MessageTemplates from "@/components/TemplateEditor/MessageTemplates.vue";
import { mapGetters } from "vuex";

export default {
  name: "sidebar-templates",
  components: { MessageTemplates },
  computed: {
    ...mapGetters(["getTemplates"])
  },
  data() {
    return {
      tabSelected: null,
      tableTabs: [
        { tabName: "My Templates", tabTag: "my_templates" },
        { tabName: "Top Performing", tabTag: "top" },
        { tabName: "B2B", tabTag: "b2b" },
        { tabName: "B2C", tabTag: "b2c" },
        { tabName: "Enterprise", tabTag: "enterprise" },
        { tabName: "SaaS", tabTag: "saas" },
        { tabName: "Service", tabTag: "service" }
      ],
      recentTemplates: [
        // "Giveaway",
        // "New Product Launch",
        // "Event Invite",
        // "Contact in Common",
        // "Introduced By"
      ],
      showModal: false
    };
  },
  props: {},
  mounted() {
    this.$eventHub.$on("update-content", template => {
      this.handleClose();
    });
  },
  methods: {
    handleClick() {
      this.showModal = true;
    },
    handleClose() {
      this.showModal = false;
    },
    selectTab(tab) {
      this.tabSelected = tab.tabTag;
    }
  }
};
</script>
